function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = React.createElement("path", {
  fill: "#E5312A",
  fillRule: "evenodd",
  d: "M11.146.147c-.196-.195-.512-.195-.708 0L6 4.586 1.56.146c-.195-.194-.511-.194-.706 0L.146.855c-.195.195-.195.512 0 .707L4.586 6l-4.44 4.439c-.195.195-.195.512 0 .707l.708.707c.195.195.511.195.707 0L6 7.414l4.438 4.44c.196.194.512.194.707 0l.708-.708c.195-.195.195-.512 0-.707L7.413 6l4.44-4.439c.195-.195.195-.512 0-.707l-.707-.707z",
  clipRule: "evenodd"
});

var SvgCrossRed = function SvgCrossRed(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCrossRed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cross-red.d349769c.svg";
export { ForwardRef as ReactComponent };